import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'portal-elements-count',
  templateUrl: './elements-count.component.html',
  styles: [],
  standalone: false,
})
export class ElementsCountComponent implements OnInit {
  @Input()
  collection: any[];

  @Input()
  displayed: any[];

  constructor() {}

  ngOnInit() {}
}
